export default __webpack_public_path__ + "static/media/0x146e58d34eab0bff7e0a63cfe9332908d680c667.b249c4b5.webp";